const number = JSON.parse(localStorage.getItem("number"));
const checkType = () => {
    if(number == "20"){
        return 'admin'
    }
    if(number == '40'){
        return 'participant'
    }
    if(number == '60'){
        return 'rater'
    }
}
export default checkType
